import { render, staticRenderFns } from "./CdrRecordingPlayer.vue?vue&type=template&id=1d421f66&scoped=true"
import script from "./CdrRecordingPlayer.vue?vue&type=script&lang=js"
export * from "./CdrRecordingPlayer.vue?vue&type=script&lang=js"
import style0 from "./CdrRecordingPlayer.vue?vue&type=style&index=0&id=1d421f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d421f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
